import React, { useState } from 'react';
import { Input } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { setData } from '../../../redux';
import { sortByDate } from '../../../../helperFunctions';

export default props => {
  const { material, smallerFontSize } = props;
  const dispatch = useDispatch();
  const data = useSelector(state => state.tasks.data);
  const startedTaskId = useSelector(state => state.tasks.taskStarted.taskId);
  const task = data.tasks.find(x => x.id === startedTaskId);

  if (!task) return null;
  const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
  const { troubleProtocol } = task;
  const { deinstalledDevices } = troubleProtocol;
  const [quantityValue, setQuantityValue] = useState(null);

  return (
    <Input
      style={{ marginBottom: '0px', padding: '0px' }}
      inputProps={{
        style: { fontSize: smallerFontSize },
        min: 0,
        max: material.quantity,
      }}
      size="small"
      margin="none"
      type="number"
      value={quantityValue}
      onChange={y => {
        if (Number.isNaN(y.target.value)) {
          return;
        }
        const value =
          Number(y.target.value) < material.quantity ? Number(y.target.value) : material.quantity;

        const updatedDeinstalledDevices = [...deinstalledDevices];
        if (value !== 0) {
          setQuantityValue(value);

          const deinstalledDevice = deinstalledDevices
            ? deinstalledDevices.find(i => i.serialNumber === material.serialNumber)
            : null;

          if (!deinstalledDevice || deinstalledDevice === null) {
            updatedDeinstalledDevices.push(material);

            const updatedTroubleProtocol = {
              ...troubleProtocol,
              deinstalledDevices: updatedDeinstalledDevices,
            };

            const updatedTask = {
              ...task,
              troubleProtocol: updatedTroubleProtocol,
            };

            const updatedTasks = [...data.tasks];
            updatedTasks.splice(taskIndex, 1, updatedTask);

            dispatch(
              setData({
                ...data,
                tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
              })
            );
          }
        } else {
          setQuantityValue(null);
          updatedDeinstalledDevices.splice(deinstalledDevices.indexOf(material), 1);

          const updatedTroubleProtocol = {
            ...troubleProtocol,
            deinstalledDevices: updatedDeinstalledDevices,
          };

          const updatedTask = {
            ...task,
            troubleProtocol: updatedTroubleProtocol,
          };

          const updatedTasks = [...data.tasks];
          updatedTasks.splice(taskIndex, 1, updatedTask);

          dispatch(
            setData({
              ...data,
              tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
            })
          );
        }
      }}
    />
  );
};
